import { render, staticRenderFns } from "./MenuGalleryImage.vue?vue&type=template&id=5f3ecaad&scoped=true&"
import script from "./MenuGalleryImage.vue?vue&type=script&lang=js&"
export * from "./MenuGalleryImage.vue?vue&type=script&lang=js&"
import style0 from "./MenuGalleryImage.vue?vue&type=style&index=0&id=5f3ecaad&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f3ecaad",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
